import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/noImg.png'
import _imports_1 from '../../assets/zt_404.png'


const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "purchasedMaterial comBox" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"position":"relative"} }
const _hoisted_6 = { style: {"display":"flex","right":"0.16rem","position":"absolute","z-index":"1"} }
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = {
  style: {},
  class: "table_img"
}
const _hoisted_9 = { class: "table_information" }
const _hoisted_10 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","color":"#333333"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 3,
  class: "satatusLab",
  style: {"background":"#4bc18520","color":"#4bc185"}
}
const _hoisted_15 = {
  key: 4,
  class: "satatusLab",
  style: {"background":"#f53f3f20","color":"#f53f3f"}
}
const _hoisted_16 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_17 = { style: {"flex":"2"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  style: {"height":"550px"}
}

import leftTemplate1 from "@/components/leftTemplate1.vue";
import purchasedMaterialAccredit from "./purchasedMaterial-accredit.vue";
import { ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import { ElTable, ElMessage } from "element-plus";
import axios from "axios";
import { Axios } from "../../assets/js/ls_com_axios.js";
import downFile from "../../assets/js/down.js";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'purchasedMaterial',
  setup(__props) {

const router = useRouter();
const activeName = ref("first");

let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
const page = pageDef;
const single = ref(true);
const multiple = ref(true);
const form = ref<any>({});
const activeList = ref([
  {
    label: "全部素材",
    name: "first",
    satus: 1,
  },
  {
    label: "视频",
    name: "second",
    satus: 2,
  },
  {
    label: "音乐",
    name: "third",
    satus: 3,
  },
  {
    label: "图片",
    name: "four",
    satus: 4,
  },
]);
const top_type = ref("");
const selectRows = ref<Array<any>>([]);
const ids = ref<Array<number>>([]);
const handleClick = (tab: TabsPaneContext, event: Event) => {
  // 素材分类（IMAGE图片 MUSIC音乐 VIDEO视频）
  isTableLoading.value = false;
  let value =
    activeName.value == "first"
      ? ""
      : activeName.value == "second"
      ? "VIDEO"
      : activeName.value == "third"
      ? "MUSIC"
      : activeName.value == "four"
      ? "IMAGE"
      : "";
  top_type.value = value;
  init();
};

// 表格

const api = axios.create({
  baseURL: "https://api.biaoshisx.com",
  timeout: 1000 * 60 * 60 * 4,
});
//列表请求
var list = ref([]); // 创建一个空数组
const isTableLoading = ref(false);

const init = () => {
  let params = {
    materialType: top_type.value,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    orderByColumn: "payTime",
    isAsc: "desc",
  };
  isTableLoading.value = false;
  Axios("get", "/fodder/manage/pay-list", params, false, function (res: any) {
    list.value = res.data.rows;
    page.value.total = res.data.total;
  });
};
const handleSelectionChange = (selection: any) => {
  selectRows.value = selection;
  single.value = selection.length != 1;
  multiple.value = !selection.length;
  ids.value = selection.map((x: any) => x.id);
};
// 填写授权信息
const dialogFormVisible = ref(false);
const addAuth = (row: any) => {
  Axios("get", "/fodder/manage/auth/" + row.id, {}, false, function (res: any) {
    form.value = res.data.data;
    if (!form.value) {
      form.value = {};
      form.value.authType = row.authType;
    }
    form.value.payId = row.id;
  });
  dialogFormVisible.value = true;
};
const onClose = () => {
  dialogFormVisible.value = false;
};
const onSubmit = () => {
  dialogFormVisible.value = false;
  Axios("post", "/fodder/manage/auth", form.value, false, function (res: any) {
    ElMessage({
      showClose: true,
      message: "授权书申请已提交",
      type: "success",
    });
  });
};
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  page.value.pageNum = val;
  init();
};
const downAuthBook = (pdf: string) => {
  let link = document.createElement("a");
  fetch(pdf)
    .then((res) => res.blob())
    .then((blob) => {
      link.href = URL.createObjectURL(blob);
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};
const downMaterials = (
  row: any,
  files: Array<{ file: string; path: string }>
) => {
  row.zipLoading = true;
  api({
    method: "post",
    url: "/file/zip",
    data: { files },
  }).then((resp) => {
    row.zipLoading = false;
    if (row.percentage == 100) {
      row.percentage = 0;
    }
    downFile({
      pieceSize: 1,
      concurrent: 3,
      fileName: resp.data,
      downName: row.title + ".zip",
      process: ({ progress }) => {
        row.percentage = parseFloat(progress.toFixed(1));
      },
    });
  });
};
const downMulMaterial = () => {
  selectRows.value.forEach((element) => {
    downMaterials(element, [
      { file: element.title + "." + element.fileExt, path: element.sourcePath },
      { file: "封面.png", path: element.showImage },
    ]);
  });
};
const addInvoice = (row) => {
  const id = row.orderId;
  if (row.hasInvoice == 0) {
    router.push({
      path: "/invoiceDebit",
      query: {
        arry: id,
        type: "add",
      },
    });
  } else {
    ElMessage.warning("该订单已申请发票");
  }
};
init();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate1, { left_tabShow: 'purchased_material' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"height":"0.08rem"} }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              class: "topBtn",
              onClick: downMulMaterial,
              disabled: multiple.value
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("批量下载素材 ")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
            class: "demo-tabs",
            onTabChange: handleClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: item.label,
                  name: item.name,
                  key: item
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElTable), {
                      data: _unref(list),
                      style: {"width":"100%"},
                      height: "550",
                      onSelectionChange: handleSelectionChange
                    }, {
                      empty: _withCtx(() => [
                        (_unref(list).length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[8] || (_cache[8] = [
                              _createElementVNode("div", { style: {"width":"90%","margin":"0 auto"} }, [
                                _createElementVNode("img", {
                                  style: {"width":"100%","margin":"0 auto"},
                                  src: _imports_1
                                })
                              ], -1)
                            ])))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "selection",
                          width: "55"
                        }),
                        _createVNode(_component_el_table_column, {
                          property: "name",
                          "min-width": "100",
                          label: "素材名称"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_el_image, {
                                  style: {"width":"100%","height":"100%"},
                                  src: scope.row.showImage,
                                  "zoom-rate": 1.2,
                                  "preview-src-list": [scope.row.showImage],
                                  "initial-index": 4,
                                  fit: "cover",
                                  "preview-teleported": true
                                }, {
                                  error: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createElementVNode("div", {
                                      class: "image-slot",
                                      style: {"width":"100%","height":"100%"}
                                    }, [
                                      _createElementVNode("img", {
                                        style: {"width":"100%","height":"100%"},
                                        src: _imports_0
                                      })
                                    ], -1)
                                  ])),
                                  _: 2
                                }, 1032, ["src", "preview-src-list"])
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(scope.row.title) + _toDisplayString(scope.row.fileExt), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "授权信息",
                          align: "center"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.authType == 'SELF')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 个人授权 "))
                              : _createCommentVNode("", true),
                            (scope.row.authType == 'ENTERPRISE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 企业授权 "))
                              : _createCommentVNode("", true),
                            (scope.row.authType == 'UNION')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 联盟授权 "))
                              : _createCommentVNode("", true),
                            (scope.row.isAuth == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已生效"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, "未生效"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "购买时间",
                          align: "center",
                          property: "payTime"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "操作",
                          width: "350",
                          align: "center"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                (!scope.row.zipLoading && !scope.row.percentage)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      style: {"width":"100px","cursor":"pointer"},
                                      onClick: ($event: any) => (
                            downMaterials(scope.row, [
                              {
                                file: scope.row.title + '.' + scope.row.fileExt,
                                path: scope.row.sourcePath,
                              },
                              { file: '封面.png', path: scope.row.showImage },
                            ])
                          ),
                                      class: "topBtn"
                                    }, " 下载素材 ", 8, _hoisted_18))
                                  : (scope.row.zipLoading)
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 1,
                                        "disable-transitions": true,
                                        type: "warning"
                                      }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                          _createTextVNode("打包中")
                                        ])),
                                        _: 1
                                      }))
                                    : (scope.row.percentage)
                                      ? (_openBlock(), _createBlock(_component_el_progress, {
                                          key: 2,
                                          "text-inside": true,
                                          "stroke-width": 15,
                                          striped: "",
                                          percentage: scope.row.percentage
                                        }, null, 8, ["percentage"]))
                                      : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                onClick: ($event: any) => (addInvoice(scope.row)),
                                style: {"width":"100px","cursor":"pointer"},
                                class: "topBtn1"
                              }, " 申请发票 ", 8, _hoisted_19),
                              (scope.row.isAuth == 1 && scope.row.authPdf)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: ($event: any) => (downAuthBook(scope.row.authPdf)),
                                    style: {"color":"#4bc185","margin-left":"0.1rem","line-height":"0.43rem","cursor":"pointer"}
                                  }, " 下载授权书 ", 8, _hoisted_20))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: ($event: any) => (addAuth(scope.row)),
                                    style: {"color":"#C01A26","margin-left":"0.1rem","line-height":"0.43rem","cursor":"pointer"}
                                  }, " 填写授权书 ", 8, _hoisted_21))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 2
                }, 1032, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_unref(list).length)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                "current-page": _unref(page).pageNum,
                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageNum) = $event)),
                "page-size": _unref(page).pageSize,
                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(page).pageSize) = $event)),
                onSizeChange: sizeChange,
                onCurrentChange: currentChange,
                style: {"margin":"0.4rem 0"},
                background: "",
                layout: "prev, pager, next",
                total: _unref(page).total
              }, null, 8, ["current-page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "填写授权信息",
      modelValue: dialogFormVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogFormVisible).value = $event)),
      "align-center": "",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(purchasedMaterialAccredit, {
          modelValue: form.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
          onClose: onClose,
          onSubmit: onSubmit
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})